import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TSetPostAttribute, ESetPostAttributeActionType, ISetPostAttribute } from './types';
import { IPostAttributes } from '../../../types/post';

export const setPostAttribute: <P extends keyof IPostAttributes>(data: ISetPostAttribute<P>) => TSetPostAttribute =
  actionGenerator<ESetPostAttributeActionType.Set, ISetPostAttribute>(ESetPostAttributeActionType.Set);
